export default "__VITE_ASSET__ye$hvuDK__"